import React from 'react';
import {Heading, HStack} from 'native-base';
import {message} from '../../../../utils/messages';

interface Props {
  label: string;
  value: string;
}

const ProfileItem = ({label, value}: Props) => {
  return (
    <HStack paddingY={3}>
      <Heading color="gray.600" size="xs" fontWeight="bold" width="25%">
        {message(label)}
      </Heading>
      <Heading
        color="gray.600"
        fontWeight="medium"
        size="xs"
        numberOfLines={1}
        textAlign="right"
        width={'75%'}>
        {value}
      </Heading>
    </HStack>
  );
};

export default ProfileItem;
